module.exports = __webpack_public_path__ + "static/media/HonestAuthenticAdvice.ce83cf71.png";